import _ from 'lodash'
import MAYA from '../maya_api'
import {appCleanVal, appSetObj, appSetVal} from "./application";

const INIT_CUSTOMER = 'INIT_CUSTOMER';
const RESET_CUSTOMER = 'RESET_CUSTOMER';
const CHANGE_CUSTOMER_MOBILE_NUMBER = 'CHANGE_CUSTOMER_MOBILE_NUMBER';
const CUSTOMER_INIT_LOADING = 'CUSTOMER_INIT_LOADING';

function initCustomer() {
  return async (dispatch, getStore) => {
    const sessionGuid = getStore().app.session_guid;
    const customerNumber = getStore().customer.phone_number;

    console.log('Init customer', customerNumber);

    dispatch(customerInitLoading(true));

    const result = await MAYA.initCustomer(sessionGuid, customerNumber);

    dispatch(customerInitLoading(false));

    dispatch(appSetObj(result));
    dispatch(changeNumber(customerNumber));

    dispatch({
      type: INIT_CUSTOMER,
      payload: result
    })
  }
}

function resetCustomer() {
  return async (dispatch, getStore) => {
    const store = getStore();

    if(_.has(store, 'app.x_data.phone_number')){
      dispatch(appCleanVal('phone_number'));
    }

    if(_.has(store, 'app.x_data.customer_id')){
      dispatch(appCleanVal('customer_id'));
    }

    dispatch(appSetVal('phone_number_valid', true));

    dispatch({
      type: RESET_CUSTOMER
    })
  };
}

function changeNumber(value = '') {
  return async (dispatch, getStore) => {

    dispatch(appSetVal('phone_number', value));

    dispatch({
      type: CHANGE_CUSTOMER_MOBILE_NUMBER,
      payload: value
    });
  }
}

function customerInitLoading(value) {
  return {
    type: CUSTOMER_INIT_LOADING,
    payload: value
  }
}

export {
  initCustomer,
  resetCustomer,
  changeNumber,
  customerInitLoading
}


// ------------------------------------
// Action Handlers
// ------------------------------------

const initialState = {
  customer_id: '',
  phone_number: '',
  customer_init_loading: false
};

const ACTION_HANDLERS = {
  [INIT_CUSTOMER]: (state, action) => ({
    ...state,
    ...action.payload
  }),
  [RESET_CUSTOMER]: (state, action) => initialState,
  [CHANGE_CUSTOMER_MOBILE_NUMBER]: (state, action) => ({
    ...state,
    phone_number: action.payload
  }),
  [CUSTOMER_INIT_LOADING]: (state, action) => ({
    ...state,
    customer_init_loading: action.payload
  })
};

export default function customerReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/customer.js